import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import { BtnGreen40 } from '../../Elements/Elements';

import classes from './ChipsSelect.module.scss';

const ChipsSelect = ({
  dataChipsSelect = [],
  isChecked,
  onClickAll,
  onCreate,
  mixpanel
}) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;

  let history = useHistory();

  const onClickChips = id => {
    trackingEvent('deleted_groups', mixpanel, username);
    if (id !== 'delete') {
      history.push(`/groups/${id}`);
    }
  };

  return (
    <div className={classes.chipsSelect}>
      <div className={classes.chipsAll}>
        <button
          onClick={() => onClickAll()}
          type="button"
          className={cn(
            classes.chipsButton,
            isChecked === 'all' && classes.chipsButton_isChecked
          )}
        >
          <p>{t('chipsSelect', 'ALL_RELEASES', language)}</p>
        </button>
      </div>
      <div className={classes.chipsWrap}>
        {dataChipsSelect.map(({ title, groupId }) => (
          <button
            key={groupId}
            onClick={() => onClickChips(groupId)}
            type="button"
            className={cn(
              classes.chipsButton,
              Number(isChecked) === Number(groupId) &&
                classes.chipsButton_isChecked
            )}
          >
            <p className={classes.hiddenText}>{title}</p>
          </button>
        ))}
        <button
          onClick={() => onClickChips('deleted')}
          type="button"
          className={cn(classes.chipsButton, classes.chipsButton_deleted)}
        >
          <p>{t('chipsSelect', 'DELETED', language)}</p>
        </button>
      </div>
      <div className={classes.addButton}>
        <BtnGreen40
          textButton={t('chipsSelect', 'CREATE_NEW_RELEASE', language)}
          onClick={onCreate}
        />
      </div>
    </div>
  );
};

ChipsSelect.propTypes = {
  dataChipsSelect: PropTypes.array,
  isChecked: PropTypes.string,
  onClickAll: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  mixpanel: PropTypes.object
};

export default ChipsSelect;
